import { useRef } from "react";
import { getDeployment, setDeployment } from "../../utilities/consts";
import { Button, Stack, TextField } from "@mui/material";

export default function SetDeployment({ setSnackbarMessage }) {
    const deploymentRef = useRef();

    const handleDeploymentApply = () => {
        const newDeployment = deploymentRef.current.value;
        setDeployment(newDeployment);
        setSnackbarMessage(`Changed deployment to ${newDeployment}`);
    };

    return (
        <Stack direction="row">
            <TextField
                inputRef={deploymentRef}
                label="Deployment"
                defaultValue={getDeployment()}
            />
            <Button onClick={handleDeploymentApply}>Apply</Button>
        </Stack>
    );
}
